import cookie from 'js-cookie'
import appConfig from 'app-config'


const getContacts = () =>
  new Promise((resolve) => {
    window.gapi.load('client', () => {
      window.gapi.client.init({
        apiKey: cookie.get('googleApiKey') || appConfig.apiKeys.googleApiKey,
        clientId: cookie.get('googleAppId') || appConfig.apiKeys.googleAppId,
        discoveryDocs: [ 'https://people.googleapis.com/$discovery/rest?version=v1' ],
        scope: [ 'profile', 'https://www.googleapis.com/auth/contacts.readonly' ].join(' '),
      })
        .then(() => (
          window.gapi.auth2.getAuthInstance().signIn()
        ))
        .then(() => (
          window.gapi.client.people.people.connections.list({
            resourceName: 'people/me',
            personFields: 'photos,names,nicknames,emailAddresses',
            pageSize: 50,
          })
        ))
        .then(({ result: { connections = [] } = {} } = {}) => {
          const users = connections.map((user) => {
            const {
              names: [ { displayName: name } = {} ] = [],
              emailAddresses: [ { value: email } = {} ] = [],
            } = user

            return { name, email }
          })

          resolve(users)
        }, (reason) => {
          console.error('Google API init error:', reason)
          resolve([])
        })
    })
  })


export default {
  getContacts,
}
